import React, { useState, useEffect, useRef } from "react";

import * as api from "helper/helper";
import toast from "react-hot-toast";

import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
//import CreateClient from "./CreateClient";

//import "./../Usuarios/usuarios.css";
import buttonStyles from "../../../../styles/Button.module.css";
//import menuStyle from "../../../../styles/Menu.module.css";
//import SearchBar from "../SearchBar";
//import { buildNameWithId } from "helper/tools";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
//import FilterButton from "../FilterButton/FilterButton";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import NotificacionesTable from "./NotificacionesTable";

export default function NotificacionesCatalogo() {
  const Menus = {
    Asociado: 0,
    Status: 1,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const createClientesRef = useRef();
  const filtrosRef = useRef([]);
  const asociadoRef = useRef();
  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [eventos, setEventos] = useState({});

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros] = useState([
    { type: Menus.Asociado, name: "Asociado" },
    {
      type: Menus.Status,
      name: "Estatus",
    },
  ]);

  /** FILTERS */
  //  const [asociados, setAsociados] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({
    tipoDeSolicitudes: ["OrdenVentaCancelada", "OrdenVentaDevolucion"],
  });
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async () => {
    setIsLoading(true);
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    /*  const responseAsociados = await api.asociados().catch((error) => {
      toast.error("Error al pedir Asociados.");
      setIsLoading(false);
    });

    if (!responseAsociados) return;

    const autoAsociados = responseAsociados.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text };
    });
    setAsociados(autoAsociados);*/
  };

  useEffect(() => {
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Notificaciones);
    setPermissions(newPermissions);
  }, []);

  function createClient(event) {
    console.log(event);
    loadItem({});
  }

  function reloadNotificaciones() {
    fetchData();
  }

  ///--
  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createClientesRef);
    setModalData(item);

    createClientesRef.current.toggleModal();
  }

  /**
   * Search handler
   */

  const clearAsociadoFilter = () => {
    handleOnChange(undefined);

    asociadoRef.current.clearInput();
  };

  const handleOnChange = (value) => {
    console.log("-->");

    let criteria = searchCriteria;
    let tagIds = [];
    let name = "";

    if (value != null && value.id != null) {
      tagIds = criteria["AsociadoIds"] ?? [];
      let tagId = value.id;
      if (!tagIds.includes(tagId)) {
        tagIds.push(tagId);
      } else {
        tagIds = tagIds.filter((f) => f !== tagId);
      }

      name = value.value;
    }

    criteria["AsociadoIds"] = tagIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Asociado;
    });
    filtrosRef.current[index].toka(name);
    filtrosRef.current[index].hideMenu();
  };

  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;
    criteria["texto"] = e;

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (value.type === Menus.Asociado && item.type === Menus.Asociado) {
        clearAsociadoFilter();
      } else if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      }
    });
  }

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);
    const response = await api.searchNotificaciones(criteria).catch((error) => {
      toast.error("Error al buscar Clientes.");
      setIsLoading(false);
    });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setEventos(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  return (
    <>
      {/*<CreateClient
        ref={createClientesRef}
        item={modalData}
        reloadNotificaciones={reloadNotificaciones}
      /> */}
      <div className="card recent-sales overflow-auto">
        {/** 
        <div className="separator"></div>*/}
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            {/*<div className="header">
              <SearchBar
                onChange={(e) => onChangeSearchText(e)}
                placeholder="Buscar por Id, Nombre y/o Alias..."
              />
            </div>*/}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
              }}
            >
              <button
                className="btn btn-primary"
                onClick={createClient}
                hidden={!permissions.canCreate}
              >
                <div className={buttonStyles.icon_button}>
                  <FaPlus />
                  Crear Cliente
                </div>
              </button>
            </div>

            {/**   <div
              className="btn-group1"
              style={{ display: "flex", columnGap: "6px" }}
            >
              {filtros.map((item, index) => {
                return (
                  <>
                    <FilterButton
                      key={index}
                      ref={(el) => (filtrosRef.current[index] = el)}
                      name={item.name}
                      clearCallback={(ble) => clearCallback(item)}
                    >
                      <ul
                        className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                        aria-labelledby="dropdownMenuClickableInside"
                      >
                        {item.type === Menus.Status &&
                          status.map((item, index) => {
                            return (
                              <TableOptionCheck
                                key={index}
                                item={item}
                                onClick={handleStatusClick}
                              />
                            );
                          })}

                        {item.type === Menus.Asociado && (
                          <TableOptionCheck
                            ref={asociadoRef}
                            key={index}
                            item={item}
                            filterType={FilterType.AutoComplete}
                            options={asociados}
                            values={asociados}
                            onChange={handleOnChange}
                          />
                        )}
                      </ul>
                    </FilterButton>
                  </>
                );
              })}
            </div>  */}
          </div>
        </div>

        {/** */}
        <nav
          aria-label="Page navigation example"
          style={{ marginRight: "20px" }}
        >
          <ul className="pagination justify-content-end">
            <li
              className={`page-item ${previousPageState}`}
              onClick={(event) => goPreviousPage()}
            >
              <a
                className="page-link"
                href="#"
                tabIndex="-1"
                aria-disabled={"true"}
              >
                <FaArrowLeft />
              </a>
            </li>

            {pageButtons.map((item) => {
              let page = pagingInfoRef.current.pageNumber();
              let disabled =
                page === item.pageNumber ? "disabled disable-paging-btn" : "";
              return (
                <li
                  className={`page-item ${disabled}`}
                  onClick={(event) => goToPage(item.pageNumber)}
                >
                  <a className="page-link" href="#">
                    {item.name}
                  </a>
                </li>
              );
            })}
            <li
              className={`page-item ${nextPageState}`}
              onClick={(event) => goNextPage()}
            >
              <a className="page-link" href="#">
                <FaArrowRight />
              </a>
            </li>
          </ul>
        </nav>

        <div className="card-body">
          <NotificacionesTable
            items={eventos}
            openItem={loadItem}
            handleSortChange={handleSortChange}
            isLoading={isLoading}
            reload={reloadNotificaciones}
          />
        </div>
      </div>
    </>
  );
}
